'use strict';
module.exports = require('./lib').path();



//////////////////
// WEBPACK FOOTER
// ./~/pngquant-bin/index.js
// module id = 3425
// module chunks = 0